/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */

import {
  IAgentPlugin,
  IPluginMethodMap,
} from '@vlinder-web/plugin-agent-service-react';

import { notificationsPayoutConfig } from '../../config/notifications.config';

export interface IStaticPagePayoutPluginMethods extends IPluginMethodMap {
  getStaticPagePayoutSync(args?: any): any;
}

export class StaticPagePayoutPlugin implements IAgentPlugin {
  readonly methods: IStaticPagePayoutPluginMethods;

  constructor() {
    this.methods = {
      getStaticPagePayoutSync: this.getStaticPagePayoutSync.bind(this),
    };
  }

  getStaticPagePayoutSync(args?: any) {
    return {
      notification: notificationsPayoutConfig,
    };
  }
}
